var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner",
      staticStyle: { "background-color": "#F5F7FA" },
      attrs: { type: "primary" }
    },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "triggers" },
          [
            !_vm.isEdit
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.oneOffice.uuid === ""
                      },
                      on: { click: _vm.toAddOffice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddBranch")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled:
                          _vm.oneOffice.uuid === "" || !!_vm.treeNode.root
                      },
                      on: { click: _vm.popCopyOffice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CopyBranch")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.oneOffice.uuid === ""
                      },
                      on: { click: _vm.toAddDept }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddDept")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.oneOffice.uuid === ""
                      },
                      on: { click: _vm.toEditOffice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                  ),
                  !(_vm.oneOffice.uuid === "" || _vm.treeNode.hasChild)
                    ? _c(
                        "el-button",
                        { attrs: { type: "danger" }, on: { click: _vm.toDel } },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.oneOffice.uuid === ""
                      },
                      on: { click: _vm.popBankAccount }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BankAccount")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.oneOffice.uuid === ""
                      },
                      on: { click: _vm.popInvoicingInfo }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_InvoicingInformation"))
                      )
                    ]
                  )
                ]
              : [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toSaveOffice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toCancelSaveOffice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                  )
                ]
          ],
          2
        )
      ]),
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "tabs-container", staticStyle: { padding: "0" } },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { lazy: true, type: "card" },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    key: 1,
                    attrs: {
                      label: _vm.$t("SeaExport.BasicInfo"),
                      name: "basicInfo"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "app-main-inner-row input-dialog" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "officeForm",
                            staticStyle: { width: "100%" },
                            attrs: {
                              "label-position": "left",
                              "label-width": "120px"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("SeaExport.GroupCode")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.code,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "code",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.code"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_BranchCnName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.chineseName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "chineseName",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.chineseName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ChineseAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.chineseAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "chineseAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.chineseAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_BranchEnName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.englishName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "englishName",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.englishName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("CargoMsg.Cargo_City")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.cityName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "cityName",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.cityName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_PostalCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "zipCode",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("CargoMsg.Cargo_Fax")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.fax,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "fax",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.fax"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("CargoMsg.Cargo_Tel")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.phone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "phone",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.phone"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("CargoMsg.Cargo_Email")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.email,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.email"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_LocalCurrency2"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          staticClass: "input-color",
                                          attrs: {
                                            filterable: "",
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Currency,
                                            "default-value":
                                              _vm.oneOffice.currency,
                                            disabled: !_vm.isEdit,
                                            clearable: false
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.oneOffice.currency = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_DefaultAirport"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "airportSelect",
                                          staticClass: "input-color",
                                          staticStyle: { flex: "1" },
                                          attrs: {
                                            no: "airportSelect",
                                            disabled: !_vm.isEdit,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Airport,
                                            filterable: "",
                                            "default-value":
                                              _vm.oneOffice.airport,
                                            "tag-name": "englishName"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.oneOffice.airport = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_DefaultHarbor"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "seaportSelect",
                                          staticClass: "input-color",
                                          staticStyle: { flex: "1" },
                                          attrs: {
                                            no: "seaportSelect",
                                            disabled: !_vm.isEdit,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Seaport,
                                            filterable: "",
                                            "default-value":
                                              _vm.oneOffice.seaport,
                                            "tag-name": "englishName"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.oneOffice.seaport = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_DefaultTimeZone"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "timezoneSelect",
                                          staticClass: "input-color",
                                          staticStyle: { flex: "1" },
                                          attrs: {
                                            no: "timezoneSelect",
                                            disabled: !_vm.isEdit,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Timezone,
                                            filterable: "",
                                            "default-value":
                                              _vm.oneOffice.timezone,
                                            "tag-name": "regionCn"
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.oneOffice.timezone = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticStyle: { "margin-right": "0" },
                                        attrs: {
                                          label:
                                            _vm.$t("baseInfo.partner.region") +
                                            "（" +
                                            _vm.$t("baseInfo.partner.area") +
                                            "）"
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          ref: "region",
                                          staticStyle: { width: "160px" },
                                          attrs: {
                                            no: "region",
                                            disabled: !_vm.isEdit,
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Country,
                                            filterable: "",
                                            "callback-params": {
                                              key: "region"
                                            },
                                            "callback-method-type": "value",
                                            "default-value":
                                              _vm.oneOffice.region
                                          },
                                          on: {
                                            parentCallBack: function(p) {
                                              _vm.oneOffice.region = p.value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.StreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.streetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "streetNo",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.streetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("hr"),
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Partners.oceanBillOfLadingAddress"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._l(6, function(count) {
                                      return _c(
                                        "el-form-item",
                                        { key: "seaAddressLine" + count },
                                        [
                                          _c("el-input", {
                                            ref: "seaAddressLine" + count,
                                            refInFor: true,
                                            staticStyle: { flex: "1" },
                                            attrs: {
                                              no: "seaAddressLine" + count,
                                              "filter-chars": false,
                                              disabled: !_vm.isEdit
                                            },
                                            on: {
                                              change: function() {
                                                return _vm.wrapAddr(
                                                  _vm.oneOffice,
                                                  "seaAddressLine" + count,
                                                  count + 1 > 6
                                                    ? null
                                                    : "seaAddressLine" +
                                                        (count + 1),
                                                  _vm.maxChars
                                                )
                                              }
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                return _vm.showBlAddressDialog(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.oneOffice[
                                                  "seaAddressLine" + count
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneOffice,
                                                  "seaAddressLine" + count,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneOffice['seaAddressLine'+count]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    _c("hr"),
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Partners.airBillOfLadingAddress"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._l(6, function(count) {
                                      return _c(
                                        "el-form-item",
                                        { key: "airAddressLine" + count },
                                        [
                                          _c("el-input", {
                                            ref: "airAddressLine" + count,
                                            refInFor: true,
                                            staticStyle: { flex: "1" },
                                            attrs: {
                                              no: "airAddressLine" + count,
                                              "filter-chars": false,
                                              disabled: !_vm.isEdit
                                            },
                                            on: {
                                              change: function() {
                                                return _vm.wrapAddr(
                                                  _vm.oneOffice,
                                                  "airAddressLine" + count,
                                                  count + 1 > 6
                                                    ? null
                                                    : "airAddressLine" +
                                                        (count + 1),
                                                  _vm.maxChars
                                                )
                                              }
                                            },
                                            nativeOn: {
                                              dblclick: function($event) {
                                                return _vm.showAirAddressDialog(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.oneOffice[
                                                  "airAddressLine" + count
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneOffice,
                                                  "airAddressLine" + count,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneOffice['airAddressLine'+count]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    _c("hr")
                                  ],
                                  2
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_RMBAccount"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.rmbAccount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "rmbAccount",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.rmbAccount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_USDAccount"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.usdAccount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "usdAccount",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.usdAccount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ReceiveRMBAccount"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value:
                                              _vm.oneOffice.receiveRmbAccount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "receiveRmbAccount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.receiveRmbAccount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ReceiveUSDAccount"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value:
                                              _vm.oneOffice.receiveUsdAccount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "receiveUsdAccount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.receiveUsdAccount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_MultiHeaderBankMode"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value:
                                                _vm.oneOffice
                                                  .multiTitleBankMode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneOffice,
                                                  "multiTitleBankMode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneOffice.multiTitleBankMode"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Enable")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: _vm.$t(
                                                "CargoMsg.Cargo_ConfirmBeforeEnable"
                                              ),
                                              placement: "right"
                                            }
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                "margin-left": "10px"
                                              },
                                              attrs: {
                                                "icon-class": "question"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_OverseasBillingAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.overseaAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "overseaAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.overseaAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_DomesticBillingAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.localAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "localAddress",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.localAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_OverseasEDICode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.ediCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "ediCode",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.ediCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ValueAddedTaxRate"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticClass: "input-color",
                                          attrs: {
                                            disabled: !_vm.isEdit,
                                            step: 0.1,
                                            precision: 3,
                                            "controls-position": "right",
                                            min: 0,
                                            max: 100
                                          },
                                          model: {
                                            value: _vm.oneOffice.taxRate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "taxRate",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.taxRate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_InvoicingTaxRate"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticClass: "input-color",
                                          attrs: {
                                            disabled: !_vm.isEdit,
                                            step: 0.1,
                                            precision: 3,
                                            "controls-position": "right",
                                            min: 0,
                                            max: 100
                                          },
                                          model: {
                                            value: _vm.oneOffice.invoiceTaxRate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "invoiceTaxRate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.invoiceTaxRate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_SettleEmail"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.clearEmail,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "clearEmail",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.clearEmail"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_TaxationSystemAPIAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: {
                                            type: "textarea",
                                            rows: "3",
                                            disabled: !_vm.isEdit
                                          },
                                          model: {
                                            value:
                                              _vm.oneOffice.sajtInvoiceService,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "sajtInvoiceService",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.sajtInvoiceService"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_TaxControlMachineNo"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c(
                                              "div",
                                              { staticStyle: { width: "79%" } },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-color",
                                                  attrs: { disabled: true },
                                                  model: {
                                                    value: _vm.clientNos,
                                                    callback: function($$v) {
                                                      _vm.clientNos = $$v
                                                    },
                                                    expression: "clientNos"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "20%",
                                                  "padding-left": "2%"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      disabled: !_vm.oneOffice
                                                        .uuid
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.editClientNoHandler
                                                    }
                                                  },
                                                  [_vm._v("...")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_InvoiceHeader"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: true },
                                          model: {
                                            value: _vm.oneOffice.invoiceTitle,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "invoiceTitle",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.invoiceTitle"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "Partners.invoiceAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: true },
                                          model: {
                                            value: _vm.oneOffice.invoiceAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "invoiceAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.invoiceAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_DepositBankAndAccountNo"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-rich-textarea", {
                                          ref: "depositBankAccount",
                                          staticStyle: {
                                            "min-height": "unset"
                                          },
                                          attrs: {
                                            disabled: true,
                                            "text-chars": 0,
                                            "warning-count": -1
                                          },
                                          model: {
                                            value:
                                              _vm.oneOffice.depositBankAccount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "depositBankAccount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.depositBankAccount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "Partners.registrationNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: true },
                                          model: {
                                            value: _vm.oneOffice.taxAccount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "taxAccount",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.taxAccount"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SystemMaintenance.WhtTax"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value: _vm.oneOffice.whtTaxMode,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneOffice,
                                                  "whtTaxMode",
                                                  $$v
                                                )
                                              },
                                              expression: "oneOffice.whtTaxMode"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Enable")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: _vm.$t(
                                                "SystemMaintenance.WhtTaxTip"
                                              ),
                                              placement: "right"
                                            }
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                "margin-left": "10px"
                                              },
                                              attrs: {
                                                "icon-class": "question"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c("hr"),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ElectronicInvoicePlatformCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.userNameEi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "userNameEi",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.userNameEi"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ElectronicInvoice"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.passWordEi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "passWordEi",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.passWordEi"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ElectronicInvoiceTaxpayer"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value: _vm.oneOffice.taxPayerIdEi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "taxPayerIdEi",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.taxPayerIdEi"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ElectronicInvoiceAuthCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: { disabled: !_vm.isEdit },
                                          model: {
                                            value:
                                              _vm.oneOffice.authorizationCodeEi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "authorizationCodeEi",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.authorizationCodeEi"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_ElectronicInvoiceRequestAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: {
                                            type: "textarea",
                                            rows: "3",
                                            disabled: !_vm.isEdit
                                          },
                                          model: {
                                            value:
                                              _vm.oneOffice.invoiceServiceEi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "invoiceServiceEi",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.invoiceServiceEi"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_InvoiceCancellationRequestAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: {
                                            type: "textarea",
                                            rows: "3",
                                            disabled: !_vm.isEdit
                                          },
                                          model: {
                                            value:
                                              _vm.oneOffice.invoiceInvalidEi,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "invoiceInvalidEi",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "oneOffice.invoiceInvalidEi"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm.isNewDelegation
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_AssociatePartners"
                                              )
                                            }
                                          },
                                          [
                                            _c("cargo-advance-select", {
                                              staticClass: "input-color",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                disabled: !_vm.isEdit,
                                                "select-type":
                                                  _vm.selectTypeNames
                                                    .basic_data_Company,
                                                "method-params": {
                                                  active: true
                                                },
                                                "tag-name": "chineseName",
                                                "tag-value": "uuid",
                                                filterable: "",
                                                "default-value":
                                                  _vm.oneOffice.companyUuid,
                                                placeholder: " "
                                              },
                                              on: {
                                                parentCallBack: function(p) {
                                                  _vm.companyUuidChangeHandler(
                                                    p
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "NVOCC SCAC" } },
                                      [
                                        _c("el-input", {
                                          staticClass: "input-color",
                                          attrs: {
                                            type: "textarea",
                                            rows: 3,
                                            disabled: !_vm.isEdit
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.showAdvanceTextDialog(
                                                "NVOCC SCAC",
                                                _vm.oneOffice.nvoccScac,
                                                function(val) {
                                                  _vm.oneOffice.nvoccScac = val
                                                }
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.oneOffice.nvoccScac,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "nvoccScac",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.nvoccScac"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("hr"),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SystemMaintenance.NotEntityCompany"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { disabled: !_vm.isEdit },
                                            model: {
                                              value:
                                                _vm.oneOffice.notEntityCompany,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneOffice,
                                                  "notEntityCompany",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneOffice.notEntityCompany"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SystemMaintenance.Marked"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: _vm.$t(
                                                "SystemMaintenance.NotEntityCompanyTip"
                                              ),
                                              placement: "right"
                                            }
                                          },
                                          [
                                            _c("svg-icon", {
                                              staticStyle: {
                                                "margin-left": "10px"
                                              },
                                              attrs: {
                                                "icon-class": "question"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("el-col", { attrs: { span: 8 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "app-main-inner-row",
                                      staticStyle: { "margin-top": "-10px" }
                                    },
                                    [
                                      _c("cargo-ag-grid", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "630px"
                                        },
                                        attrs: {
                                          "show-side-bar": false,
                                          "grid-options":
                                            _vm.imageGrid.gridOptions,
                                          "column-defs": _vm.imageGridColumnDef,
                                          "row-data": _vm.imageGrid.rowData
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "app-main-inner-row row-grid-dialog"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "triggers",
                                          staticStyle: { display: "flex" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "padding-right": "5px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-upload",
                                                {
                                                  attrs: {
                                                    action: "",
                                                    accept:
                                                      "image/png, image/jpeg",
                                                    "show-file-list": false,
                                                    "on-change":
                                                      _vm.toChooseImage,
                                                    "file-list": [],
                                                    limit: 1,
                                                    "on-exceed":
                                                      _vm.toChooseImage,
                                                    "auto-upload": false
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        slot: "trigger",
                                                        size: "mini",
                                                        disabled: !_vm.isEdit,
                                                        type: "primary"
                                                      },
                                                      slot: "trigger"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Partners.SelectFile"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    disabled: !_vm.isEdit,
                                                    type: "primary"
                                                  },
                                                  on: { click: _vm.commitImage }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Save"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "mini",
                                                    disabled:
                                                      !_vm.isEdit ||
                                                      !_vm.imageGrid
                                                        .selectedData,
                                                    type: "danger"
                                                  },
                                                  on: {
                                                    click: _vm.toBatchDelImage
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Partners.DeleteFile"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm.$store.getters.isPlatform
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 2,
                        attrs: {
                          label: _vm.$t("CargoMsg.InvoiceConfig"),
                          name: "invoiceConfig"
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "label-position": "right",
                                  "label-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: " " } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        staticStyle: {
                                          width: "300px",
                                          display: "flex"
                                        },
                                        attrs: {
                                          no: "titleMode",
                                          disabled: !_vm.isEdit
                                        },
                                        model: {
                                          value: _vm.oneOffice.titleMode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.oneOffice,
                                              "titleMode",
                                              $$v
                                            )
                                          },
                                          expression: "oneOffice.titleMode"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          {
                                            staticStyle: {
                                              "margin-right": "10px"
                                            },
                                            attrs: {
                                              no: "SingleTitleMode",
                                              label: 0
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_SingleTitleMode"
                                                )
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: {
                                              no: "MultipleTitleMode",
                                              label: 1
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_MultipleTitleMode"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.oneOffice.titleMode,
                                expression: "oneOffice.titleMode"
                              }
                            ]
                          },
                          [
                            _c("office-invoice-config", {
                              ref: "officeInvoiceConfig",
                              attrs: {
                                "office-id": _vm.oneOffice.officeId,
                                "is-edit": _vm.isEdit
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.oneOffice.titleMode,
                                expression: "!oneOffice.titleMode"
                              }
                            ],
                            staticClass: "app-main-inner-row input-dialog"
                          },
                          [
                            _c(
                              "el-form",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "label-position": "right",
                                  "label-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.InvoiceChannel"
                                          ),
                                          required: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "300px" },
                                            attrs: {
                                              no: "invoiceChannel",
                                              disabled: !_vm.isEdit
                                            },
                                            on: {
                                              change: _vm.invoiceChannelChange
                                            },
                                            model: {
                                              value:
                                                _vm.oneOffice.invoiceChannel,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.oneOffice,
                                                  "invoiceChannel",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "oneOffice.invoiceChannel"
                                            }
                                          },
                                          _vm._l(
                                            _vm.SystemConstants
                                              .INVOICE_CHANNEL_STATUS,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.code,
                                                attrs: {
                                                  label: item.chineseName,
                                                  value: item.code
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm.isNuoNuo
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "APPkey",
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-color",
                                                  staticStyle: {
                                                    width: "300px"
                                                  },
                                                  attrs: {
                                                    no: "appKey",
                                                    disabled: !_vm.isEdit
                                                  },
                                                  model: {
                                                    value: _vm.oneOffice.appKey,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.oneOffice,
                                                        "appKey",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "oneOffice.appKey"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "APPSecret",
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "300px"
                                                  },
                                                  attrs: {
                                                    no: "appSecret",
                                                    disabled: !_vm.isEdit
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.oneOffice.appSecret,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.oneOffice,
                                                        "appSecret",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "oneOffice.appSecret"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "Token",
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "300px"
                                                  },
                                                  attrs: {
                                                    no: "token",
                                                    disabled: !_vm.isEdit
                                                  },
                                                  model: {
                                                    value: _vm.oneOffice.token,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.oneOffice,
                                                        "token",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "oneOffice.token"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.isBwjsy
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "APPId",
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticClass: "input-color",
                                                  staticStyle: {
                                                    width: "300px"
                                                  },
                                                  attrs: {
                                                    no: "APPId",
                                                    disabled: !_vm.isEdit
                                                  },
                                                  model: {
                                                    value: _vm.oneOffice.appKey,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.oneOffice,
                                                        "appKey",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "oneOffice.appKey"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "APPSecret",
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  staticStyle: {
                                                    width: "300px"
                                                  },
                                                  attrs: {
                                                    no: "appSecret",
                                                    disabled: !_vm.isEdit
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.oneOffice.appSecret,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.oneOffice,
                                                        "appSecret",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "oneOffice.appSecret"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.isNuoNuo || _vm.isBwjsy
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.Invoicer"
                                                  ),
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c("cargo-ag-grid", {
                                                  style:
                                                    (_vm.isBwjsy
                                                      ? "width:670px;"
                                                      : "width:500px;") +
                                                    "height:200px;",
                                                  attrs: {
                                                    "show-side-bar": false,
                                                    "grid-options":
                                                      _vm.invoiceGrid
                                                        .gridOptions,
                                                    "column-defs":
                                                      _vm.invoiceGridColumnDefs,
                                                    "row-data":
                                                      _vm.finalInvoiceRowData
                                                  },
                                                  on: {
                                                    gridReady: function(
                                                      params
                                                    ) {
                                                      return (this$1.invoiceGrid.gridApi =
                                                        params.api)
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "CargoMsg.InvoicerConfig"
                                                  ),
                                                  required: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    staticStyle: {
                                                      width: "300px"
                                                    },
                                                    attrs: {
                                                      no: "invoicerConfig",
                                                      disabled: !_vm.isEdit
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.oneOffice
                                                          .invoicerConfig,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.oneOffice,
                                                          "invoicerConfig",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "oneOffice.invoicerConfig"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        staticStyle: {
                                                          "margin-right": "10px"
                                                        },
                                                        attrs: {
                                                          no: "OnlyInvoicer",
                                                          label: 0
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "CargoMsg.OnlyInvoicer"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: {
                                                          no: "AllInvoicer",
                                                          label: 1
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "CargoMsg.AllInvoicer"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 10 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            _vm.$t(
                                              "CargoMsg.Cargo_CustomFields"
                                            ) + "1"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "300px" },
                                          attrs: {
                                            no: "customField1",
                                            disabled: !_vm.isEdit
                                          },
                                          model: {
                                            value: _vm.oneOffice.customField1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "customField1",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.customField1"
                                          }
                                        }),
                                        _vm.isNuoNuo
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticStyle: {
                                                  "padding-left": "7px"
                                                },
                                                attrs: {
                                                  content: _vm.$t(
                                                    "CargoMsg.Cargo_NuoNuoTipOne"
                                                  ),
                                                  placement: "right-end"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-warning",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                    color: "orange"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            _vm.$t(
                                              "CargoMsg.Cargo_CustomFields"
                                            ) + "2"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "300px" },
                                          attrs: {
                                            no: "customField2",
                                            disabled: !_vm.isEdit
                                          },
                                          model: {
                                            value: _vm.oneOffice.customField2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "customField2",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.customField2"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label:
                                            _vm.$t(
                                              "CargoMsg.Cargo_CustomFields"
                                            ) + "3"
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "300px" },
                                          attrs: {
                                            no: "customField3",
                                            disabled: !_vm.isEdit
                                          },
                                          model: {
                                            value: _vm.oneOffice.customField3,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.oneOffice,
                                                "customField3",
                                                $$v
                                              )
                                            },
                                            expression: "oneOffice.customField3"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.$store.getters.isPlatform
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 5,
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_TaxInputConfig"),
                          name: "inputTaxConfig"
                        }
                      },
                      [
                        _c("office-input-tax-config", {
                          ref: "officeInputTaxConfig",
                          attrs: {
                            "office-id": _vm.oneOffice.officeId,
                            "is-edit": _vm.isEdit
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-tab-pane",
                  {
                    key: 3,
                    attrs: {
                      label: _vm.$t(
                        "SeaExport.CounterTerrorismManifestConfiguration"
                      ),
                      name: "manifestConfig"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "app-main-inner-row input-dialog",
                        staticStyle: { height: "735px" }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "label-position": "right",
                              "label-width": "120px"
                            }
                          },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 10 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_EFreighAMSAccount"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-color",
                                      attrs: {
                                        type: "textarea",
                                        rows: 1,
                                        disabled: !_vm.isEdit
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          _vm.showAdvanceTextDialog(
                                            _vm.$t(
                                              "CargoMsg.Cargo_EFreighAMSAccount"
                                            ),
                                            _vm.oneOffice.efreighAms,
                                            function(val) {
                                              _vm.oneOffice.efreighAms = val
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.oneOffice.efreighAms,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneOffice,
                                            "efreighAms",
                                            $$v
                                          )
                                        },
                                        expression: "oneOffice.efreighAms"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_EFreighACIAccount"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-color",
                                      attrs: {
                                        type: "textarea",
                                        rows: 1,
                                        disabled: !_vm.isEdit
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          _vm.showAdvanceTextDialog(
                                            _vm.$t(
                                              "CargoMsg.Cargo_EFreighACIAccount"
                                            ),
                                            _vm.oneOffice.efreighAci,
                                            function(val) {
                                              _vm.oneOffice.efreighAci = val
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.oneOffice.efreighAci,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneOffice,
                                            "efreighAci",
                                            $$v
                                          )
                                        },
                                        expression: "oneOffice.efreighAci"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "E-Freight Company Code",
                                      title: "E-Freight Company Code"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-color",
                                      attrs: {
                                        type: "textarea",
                                        rows: 3,
                                        disabled: !_vm.isEdit
                                      },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          return _vm.showAdvanceTextDialog(
                                            "E-Freight Company Code",
                                            _vm.oneOffice.efreighCompanyCode,
                                            function(val) {
                                              _vm.oneOffice.efreighCompanyCode = val
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.oneOffice.efreighCompanyCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneOffice,
                                            "efreighCompanyCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "oneOffice.efreighCompanyCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.AfrAccount")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-color",
                                      attrs: { rows: 1, disabled: !_vm.isEdit },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          _vm.showAdvanceTextDialog(
                                            _vm.$t("SeaExport.AfrAccount"),
                                            _vm.oneOffice.jsAfrAccount,
                                            function(val) {
                                              _vm.oneOffice.efreighCompanyCode = val
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.oneOffice.jsAfrAccount,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneOffice,
                                            "jsAfrAccount",
                                            $$v
                                          )
                                        },
                                        expression: "oneOffice.jsAfrAccount"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.AfrPassword")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "input-color",
                                      attrs: { rows: 1, disabled: !_vm.isEdit },
                                      nativeOn: {
                                        dblclick: function($event) {
                                          _vm.showAdvanceTextDialog(
                                            _vm.$t("SeaExport.AfrPassword"),
                                            _vm.oneOffice.jsAfrPassword,
                                            function(val) {
                                              _vm.oneOffice.efreighCompanyCode = val
                                            }
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.oneOffice.jsAfrPassword,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.oneOffice,
                                            "jsAfrPassword",
                                            $$v
                                          )
                                        },
                                        expression: "oneOffice.jsAfrPassword"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.DeclarantEORI")
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _vm.oneOffice.officeEoriList &&
                                        _vm.oneOffice.officeEoriList.length &&
                                        _vm.oneOffice.officeEoriList.filter(
                                          function(item) {
                                            return item.action !== "delete"
                                          }
                                        ).length
                                          ? _c(
                                              "div",
                                              { staticClass: "eori-list" },
                                              _vm._l(
                                                _vm.oneOffice.officeEoriList,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        item.uuid ||
                                                        item.newUuid
                                                    },
                                                    [
                                                      item.action !== "delete"
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "eori-item",
                                                              staticStyle: {
                                                                display: "flex",
                                                                "align-items":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "205px"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.eori
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.isEdit,
                                                                    expression:
                                                                      "isEdit"
                                                                  }
                                                                ],
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "5px",
                                                                  cursor:
                                                                    "pointer"
                                                                },
                                                                attrs: {
                                                                  src: require("@/assets/icons/eori-edit.png"),
                                                                  alt: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.eoriEditHandler(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              }),
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.isEdit,
                                                                    expression:
                                                                      "isEdit"
                                                                  }
                                                                ],
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "5px",
                                                                  cursor:
                                                                    "pointer"
                                                                },
                                                                attrs: {
                                                                  src: require("@/assets/icons/eori-delete.png"),
                                                                  alt: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.eoriDeleteHandler(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              }),
                                                              _c("img", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.isEdit &&
                                                                      _vm.canAddEori,
                                                                    expression:
                                                                      "isEdit && canAddEori"
                                                                  }
                                                                ],
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "5px",
                                                                  cursor:
                                                                    "pointer"
                                                                },
                                                                attrs: {
                                                                  src: require("@/assets/icons/eori-add.png"),
                                                                  alt: ""
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.eoriAddHandler
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center"
                                                }
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    disabled: true,
                                                    title: _vm.$t(
                                                      "SeaExport.DeclarantEORI"
                                                    ),
                                                    no: "86"
                                                  }
                                                }),
                                                _c("img", {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isEdit,
                                                      expression: "isEdit"
                                                    }
                                                  ],
                                                  staticStyle: {
                                                    "margin-left": "5px",
                                                    cursor: "pointer"
                                                  },
                                                  attrs: {
                                                    src: require("@/assets/icons/eori-add.png"),
                                                    alt: ""
                                                  },
                                                  on: {
                                                    click: _vm.eoriAddHandler
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 4,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_TabEnterpriseWechat"),
                      name: "enterpriseWechat"
                    }
                  },
                  [
                    _c("tab-enterprise-wechat", {
                      attrs: {
                        office: _vm.oneOffice,
                        "active-tab-name": _vm.activeTabName
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.copyOfficeDialog.isShow,
            title: _vm.$t("CargoMsg.Cargo_CopyBranch"),
            width: "300px;"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.copyOfficeDialog, "isShow", $event)
            },
            close: function($event) {
              _vm.copyOfficeDialog.isShow = false
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NewBranchInformation")))
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: false,
                    "label-width": "150px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-item-wrapper" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CompanyCode") } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.copyOfficeDialog.code,
                              callback: function($$v) {
                                _vm.$set(_vm.copyOfficeDialog, "code", $$v)
                              },
                              expression: "copyOfficeDialog.code"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_BranchCnName")
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.copyOfficeDialog.chineseName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.copyOfficeDialog,
                                  "chineseName",
                                  $$v
                                )
                              },
                              expression: "copyOfficeDialog.chineseName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_BranchEnName")
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.copyOfficeDialog.englishName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.copyOfficeDialog,
                                  "englishName",
                                  $$v
                                )
                              },
                              expression: "copyOfficeDialog.englishName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_LocalCurrency2")
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.copyOfficeDialog.currency,
                              callback: function($$v) {
                                _vm.$set(_vm.copyOfficeDialog, "currency", $$v)
                              },
                              expression: "copyOfficeDialog.currency"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c("div", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("SystemMaintenance.NoteCopyFollowingInformation", [
                      _vm.oneOffice.chineseName
                    ])
                  )
                )
              ]),
              _c("div", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("SystemMaintenance.N1DepartmentsAndPositionBranch")
                  )
                )
              ]),
              _c("div", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.N2ParameterConfiguration"))
                )
              ]),
              _c("div", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(_vm.$t("SystemMaintenance.N3OrderNumberConfiguration"))
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.toSubmitCopyOffice }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.toCancelCopyOffice }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "eori-dialog",
          attrs: {
            "custom-class": "",
            "close-on-click-modal": false,
            visible: _vm.eoriInfoDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_EORIDetail")
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.eoriInfoDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: {
                "font-size": "14px",
                "margin-left": "12px",
                "margin-right": "16px"
              },
              attrs: {
                disabled: !_vm.isEdit,
                "label-width": "110px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { title: _vm.$t("SeaExport.CompanyTitle") } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#1f75d5 !important" },
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CompanyTitle")))]
                  ),
                  _c("el-input", {
                    attrs: { no: "eoriInfoName" },
                    model: {
                      value: _vm.eoriInfo.name,
                      callback: function($$v) {
                        _vm.$set(_vm.eoriInfo, "name", $$v)
                      },
                      expression: "eoriInfo.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { title: _vm.$t("SeaExport.Addr") + "1" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#1f75d5 !important" },
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Addr") + "1"))]
                  ),
                  _c("el-input", {
                    attrs: { no: "eoriInfoAddress2" },
                    model: {
                      value: _vm.eoriInfo.address1,
                      callback: function($$v) {
                        _vm.$set(_vm.eoriInfo, "address1", $$v)
                      },
                      expression: "eoriInfo.address1"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { title: _vm.$t("SeaExport.Addr") + "2" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.$t("SeaExport.Addr") + "2"))
                  ]),
                  _c("el-input", {
                    attrs: { no: "eoriInfoAddress2" },
                    model: {
                      value: _vm.eoriInfo.address2,
                      callback: function($$v) {
                        _vm.$set(_vm.eoriInfo, "address2", $$v)
                      },
                      expression: "eoriInfo.address2"
                    }
                  })
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    staticStyle: { color: "#1f75d5 !important" },
                    attrs: {
                      slot: "label",
                      title: _vm.$t("SeaExport.HouseNumber")
                    },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.HouseNumber")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "35%"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: _vm.eoriInfo.noHouseNumberFlag,
                            no: "eoriInfoStreetNo"
                          },
                          model: {
                            value: _vm.eoriInfo.streetNo,
                            callback: function($$v) {
                              _vm.$set(_vm.eoriInfo, "streetNo", $$v)
                            },
                            expression: "eoriInfo.streetNo"
                          }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "25px" },
                            on: { change: _vm.changeNoHouseNumberFlag },
                            model: {
                              value: _vm.eoriInfo.noHouseNumberFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.eoriInfo, "noHouseNumberFlag", $$v)
                              },
                              expression: "eoriInfo.noHouseNumberFlag"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NoHouseNumber")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "50%"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "center-label",
                            attrs: { title: _vm.$t("SeaExport.ZIP") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.ZIP")))]
                        ),
                        _c("el-input", {
                          attrs: { no: "eoriInfoPostalcode" },
                          model: {
                            value: _vm.eoriInfo.postalcode,
                            callback: function($$v) {
                              _vm.$set(_vm.eoriInfo, "postalcode", $$v)
                            },
                            expression: "eoriInfo.postalcode"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    attrs: { slot: "label", title: _vm.$t("SeaExport.City") },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.City")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "35%"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "eoriInfoCity" },
                          model: {
                            value: _vm.eoriInfo.city,
                            callback: function($$v) {
                              _vm.$set(_vm.eoriInfo, "city", $$v)
                            },
                            expression: "eoriInfo.city"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "50%"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "center-label",
                            attrs: { title: _vm.$t("SeaExport.Country") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Country")))]
                        ),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "sellerCountry",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Country,
                            cache: false,
                            filterable: "",
                            "default-value": _vm.eoriInfo.country,
                            "filter-tag-names": ["code", "chineseName", "name"],
                            "tag-name": "code",
                            "tag-value": "code",
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return this$1.isZh
                                ? item.code +
                                    " | " +
                                    item.chineseName +
                                    " | " +
                                    item.name
                                : item.code + " | " + item.name
                            },
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.eoriInfo.country = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c("el-form-item", [
                _c(
                  "span",
                  {
                    attrs: { slot: "label", title: _vm.$t("SeaExport.Tel") },
                    slot: "label"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "35%"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "eoriInfoTel" },
                          model: {
                            value: _vm.eoriInfo.tel,
                            callback: function($$v) {
                              _vm.$set(_vm.eoriInfo, "tel", $$v)
                            },
                            expression: "eoriInfo.tel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          width: "50%"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "center-label",
                            attrs: { title: _vm.$t("SeaExport.Email2") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Email2")))]
                        ),
                        _c("el-input", {
                          attrs: { no: "eoriInfoEmail" },
                          model: {
                            value: _vm.eoriInfo.email,
                            callback: function($$v) {
                              _vm.$set(_vm.eoriInfo, "email", $$v)
                            },
                            expression: "eoriInfo.email"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c(
                "el-form-item",
                [
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#1f75d5 !important" },
                      attrs: { slot: "label", title: "EORI" },
                      slot: "label"
                    },
                    [_vm._v(_vm._s("EORI"))]
                  ),
                  _c("el-input", {
                    attrs: { no: "eoriInfoEori" },
                    model: {
                      value: _vm.eoriInfo.eori,
                      callback: function($$v) {
                        _vm.$set(_vm.eoriInfo, "eori", $$v)
                      },
                      expression: "eoriInfo.eori"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.eoriInfoDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.saveEoriInfo }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.bankAccountDialog.visible
        ? _c("bank-account-title-window", {
            attrs: {
              visible: _vm.bankAccountDialog.visible,
              "tree-node": _vm.treeNode,
              "one-office": _vm.oneOffice
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.bankAccountDialog, "visible", $event)
              },
              cancelHandler: _vm.cancelHandler
            }
          })
        : _vm._e(),
      _vm.editClientNo.visible
        ? _c("client-no-window", {
            attrs: {
              visible: _vm.editClientNo.visible,
              "row-data": _vm.editClientNo.rowData,
              "dept-list": _vm.editClientNo.deptList,
              "one-office": _vm.oneOffice
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editClientNo, "visible", $event)
              },
              cancelHandler: _vm.cancelHandler,
              updateClientNos: _vm.updateClientNos
            }
          })
        : _vm._e(),
      _vm.invoicingInfoDialog.visible
        ? _c("invoicing-info-dialog", {
            attrs: {
              visible: _vm.invoicingInfoDialog.visible,
              office: _vm.invoicingInfoDialog.office,
              "tax-control-panels": _vm.invoicingInfoDialog.taxControlPanels
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoicingInfoDialog, "visible", $event)
              },
              officeChange: _vm.onOfficeChange
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { disabled: !_vm.isEdit, type: "textarea", rows: "10" },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary" }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }